export default class ScrollHelper {
    constructor(rootStore) {
        window.addEventListener("scroll",  () => {
            const {scrollHeight, clientHeight, scrollTop} = document.documentElement;
            const winScroll = document.body.scrollTop || scrollTop;
            const winHeight = scrollHeight - clientHeight;
            if (winHeight > 0) {
                rootStore.setScrollProgress(winScroll / winHeight);
            } else {
                rootStore.setScrollProgress(0);
            }
        });
    }
}
